import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";
import { useSettings, mediaUrl } from "@/context/SettingsContext";

const PromoBanner = () => {
  const { settings } = useSettings();
  const p = settings.promo;
  if (!p?.enabled || (!p.title && !p.text)) return null;
  const external = p.link?.startsWith("http");
  const Btn = p.link ? (external ? "a" : Link) : "span";
  const btnProps = p.link ? (external ? { href: p.link, target: "_blank", rel: "noopener noreferrer" } : { to: p.link }) : {};

  return (
    <section className="mx-auto max-w-7xl px-5 pb-6 sm:px-8" data-testid="promo-banner">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="relative overflow-hidden rounded-[2rem] bg-gold text-white shadow-2xl shadow-gold/25">
        <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-white/15" />
        <div className="relative grid items-center gap-6 p-8 sm:p-10 lg:grid-cols-[1fr_auto]">
          <div className="flex items-start gap-5">
            {p.image_url ? (
              <img src={mediaUrl(p.image_url)} alt="" className="hidden h-24 w-24 shrink-0 rounded-2xl object-cover shadow-lg sm:block" data-testid="promo-image" />
            ) : (
              <span className="hidden h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-white/20 sm:flex"><Sparkles className="h-7 w-7" /></span>
            )}
            <div>
              {p.title && <h2 className="font-display text-2xl font-extrabold leading-tight sm:text-3xl" data-testid="promo-title">{p.title}</h2>}
              {p.text && <p className="mt-2 max-w-2xl text-sm text-white/90 sm:text-base" data-testid="promo-text">{p.text}</p>}
            </div>
          </div>
          {p.link && (
            <Btn {...btnProps} data-testid="promo-button" className="group inline-flex items-center gap-3 whitespace-nowrap rounded-full bg-white px-7 py-4 font-mono text-xs font-semibold uppercase tracking-[0.2em] text-gold transition-all hover:-translate-y-0.5 hover:bg-forest hover:text-white">
              {p.button || "En savoir plus"}
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1.5" />
            </Btn>
          )}
        </div>
      </motion.div>
    </section>
  );
};

export default PromoBanner;
